module.exports = __webpack_public_path__ + "static/media/ProfilePic.673d1fbe.jpg";